<div class="section over-hide padding-top-bottom-120 section-background-rana-3">
    <div class="section-1400">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <h6 class="color-primary text-uppercase p-2">
                    RANA Constitution
                </h6>
                <div class="col-12">
                    <pdf-viewer
                            [src]="'./assets/pdf/rana_constitution.pdf'"
                            [render-text]="true"
                            [autoresize]="true"
                            [zoom]="zoomLevel"
                            class="pdf-view"
                    >
                    </pdf-viewer>
                </div>
            </div>
        </div>
    </div>
</div>
